<template>
    <div>
        <div class="payroll-header-overflow" v-if="incomeDetail">
            <div class="payroll-detail-header" v-if="incomeDetail.employee">
                <div class="detail-header-col staff-info-col">
                    <div class="header-card">
                        <div class="w-full tooltip">
                            <vs-button class="w-full tooltip-staff-avatar" @click.stop>
                                <span class="flex flex-col align-center" style="width: inherit; overflow: hidden;">
                                    <vs-avatar :src="incomeDetail.employee.image_url" 
                                        :text="StringHelper.changeFormatAvatar(incomeDetail.employee.name)"
                                        :color="incomeDetail.employee.color_code ? incomeDetail.employee.color_code : '#2979FF'"
                                        class="border-2 border-solid border-white text-xl" size="45px"></vs-avatar>
                                    <span class="color-black font-bold text-sm" style="width: inherit; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;">
                                        {{incomeDetail.employee.name}}
                                    </span>
                                </span>
                            </vs-button>
                            <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{incomeDetail.employee.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="detail-header-col commission-col">
                    <div class="text-sm header-card">
                        <div class="w-full border-bottom-custom color-black font-bold commission-title">
                            Employee - Owner Commission
                        </div>
                        <div class="commission-body">
                            <div class="flex-center flex-col commission-for">
                                <p class="text-grey-custom font-bold pb-15">For Service</p>
                                <p class="text-primary font-bold text-lg"
                                    v-if="commissionData && commissionData.type != 'salary'">
                                    {{formatPercent(commissionData.service_rate)}} - {{formatPercent(1 - commissionData.service_rate)}}
                                </p>
                                <p class="text-primary font-bold text-lg" v-else>0 - 100</p>
                            </div>
                            <div class="flex-center flex-col border-left-custom border-right-custom commission-for">
                                <p class="text-grey-custom font-bold pb-15">For Product</p>
                                <p class="text-primary font-bold text-lg"
                                    v-if="commissionData && commissionData.type != 'salary'">
                                    {{formatPercent(commissionData.product_rate)}} - {{formatPercent(1 - commissionData.product_rate)}}
                                </p>
                                <p class="text-primary font-bold text-lg" v-else>0 - 100</p>
                            </div>
                            <div class="flex-center flex-col commission-for">
                                <p class="text-grey-custom font-bold pb-15">For Giftcard</p>
                                <p class="text-primary font-bold text-lg"
                                    v-if="commissionData && commissionData.type != 'salary'">
                                    {{formatPercent(commissionData.gift_card_rate)}} - {{formatPercent(1 - commissionData.gift_card_rate)}}
                                </p>
                                <p class="text-primary font-bold text-lg" v-else>0 - 100</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-header-col" v-if="commissionData">
                    <div class="text-sm header-card">
                        <template v-if="commissionData.is_fixed_amount != 1">
                            <p class="color-black font-bold pb-1">Cash - Check Percentage</p>
                            <p class="text-primary font-bold text-lg">
                                {{formatPercent(commissionData.cash_check_percentage)}} - {{formatPercent(1 - commissionData.cash_check_percentage)}}
                            </p>
                        </template>
                        <template v-else>
                            <p class="color-black font-bold pb-1">{{ commissionData.check_fixed_amount ? "Max Check Income" : "Max Cash Income" }}</p>
                            <p class="text-primary font-bold text-lg">
                                {{formatFloatNum((commissionData.check_fixed_amount || commissionData.cash_fixed_amount || 0) / 100)}}
                            </p>
                        </template>
                    </div>
                </div>
                <div class="detail-header-col">
                    <div class="text-sm header-card">
                        <p class="color-black font-bold pb-1">Card Charge</p>
                        <p class="text-primary font-bold text-lg" 
                            v-if="commissionData && commissionData.type != 'salary'">
                            {{formatFloatNum(commissionData.card_charge)}}%
                        </p>
                        <p class="text-primary font-bold text-lg" v-else>0%</p>
                    </div>
                </div>
                <div class="detail-header-col">
                    <div class="text-sm header-card">
                        <p class="color-black font-bold pb-1">Tip Charge</p>
                        <p class="text-primary font-bold text-lg" v-if="commissionData">
                            {{formatFloatNum(commissionData.tip_to_check_percentage)}}%
                        </p>
                        <p class="text-primary font-bold text-lg" v-else>0%</p>
                    </div>
                </div>

                <div class="detail-header-col">
                    <div class="text-sm header-card">
                        <p class="color-black font-bold pb-1" v-if="salary_type == 0">Salary</p>
                        <div class="flex items-start color-black font-bold pb-1" v-else>Wage per hour
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current cursor-pointer ml-2" 
                                style="transform: translateY(-2px)"
                                @click="openWagePerHourPopup"
                            />
                        </div>
                        <p class="text-primary font-bold text-lg" 
                            v-if="commissionData && commissionData.type != 'commission'">
                            <span v-if="salary_type == 0">${{+(Math.round(commissionData.salary_by_period + "e+3") + "e-3")}}</span>
                            <span v-else>
                                <span v-if="approved_commission">
                                    <span v-if="commissionData.work_hours && commissionData.work_hours != 0 && (commissionData.salary_by_period / commissionData.work_hours) != 0">
                                        ${{+(Math.round((commissionData.salary_by_period / commissionData.work_hours) + "e+3") + "e-3")}}
                                    </span>
                                    <span v-else>
                                        ${{+(Math.round(commissionData.salary_per_hour + "e+3") + "e-3")}}
                                    </span>
                                </span>
                                <span v-else>
                                    ${{+(Math.round(commissionData.salary_per_hour + "e+3") + "e-3")}}
                                </span>
                            </span>
                        </p>
                        <p class="text-primary font-bold text-lg" v-else>$0</p>
                    </div>
                </div>

                <div class="flex align-center justify-end detail-header-col edit-btn-col" v-if="incomeDetail && incomeDetail.employee && incomeDetail.employee.approved_commission == null">
                    <vs-button class="rounded-10 edit-btn" @click="editStaffConfig.isOpen = true; edit_staff_key++">Edit</vs-button>
                </div>
            </div>
        </div>

        <div class="flex justify-between align-center mt-6">
            <p class="text-sm font-bold">
                <span class="color-black">Staff - Transactions detail: {{incomeDetail.employee.name}} - </span>
                <span class="text-primary" v-if="showDetailData">
                    {{formatDate(showDetailData.start_date)}} - {{formatDate(showDetailData.end_date)}} 
                    ({{getDuration(showDetailData.start_date, showDetailData.end_date)}} 
                    <span v-if="getDuration(showDetailData.start_date, showDetailData.end_date) > 1">days)</span>
                    <span v-else>day)</span>
                </span>
            </p>
            <vs-button class="gradient gradient-primary no-shadow export-btn" @click="exportIncomeDetail">
                <div class="flex-center">
                    <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                    Export
                </div>
            </vs-button>
        </div>

        <div class="transaction-detail mt-6">
            <div class="transaction-table-overflow">
                <vx-card class="font-bold color-black transaction-first-table item-rounded shadow-md" v-if="totalTableData && this.totalTableData.length > 0">
                    <div class="text-center w-full header text-sm flex-center">
                        <div class="text-uppercase p-6 px-1" v-for="(item, index) in totalTableData" :key="index" :style="`width: calc(95% / ${totalTableData.length} + ${index == totalTableData.length - 1 ? 5 : 0}%);`">{{item.name}}</div>
                    </div>
                    <div class="text-center w-full body">
                        <div class="table-td p-6 text-lg" v-for="(item, index) in totalTableData" :key="index" :style="`width: calc(95% / ${totalTableData.length} + ${index == totalTableData.length - 1 ? 5 : 0}%);`">
                            <span v-if="item.name != 'working hours'">${{item.value}}</span>
                            <span v-else>{{item.value}}</span>
                        </div>
                    </div>
                </vx-card>
            </div>
            
            <div class="transaction-table-overflow">
                <div class="mt-base font-bold color-black transaction-second-table">
                    <div class="text-center w-full header text-sm flex-center">
                        <div class="text-uppercase text-center p-4 px-1" v-for="(name, index) in orderDetailName" :key="index"
                            :style="`width: calc(100% / ${orderDetailName.length + 1} * ${index == 0 || index == 1 ? 1 : (index == 2 || index == orderDetailName.length - 1 ? 1.5 : 1)})`"
                        >{{name}}</div>
                    </div>
                    <div class="text-center w-full" v-if="orderDetailData && orderDetailData.length > 0">
                        <div class="text-center w-full" v-for="(order_by_time, time_index) in orderDetailData" :key="time_index">
                            <div class="text-center w-full" v-for="(order, index) in order_by_time.order_items" :key="index">
                                <div class="w-full bg-white flex mb-6 shadow-md rounded-item position-relative" v-if="order.order_items && order.order_items.length > 0" :class="{'mt-base border-tl-radius-0': order.is_partial_refunded == true || order.is_settlement_fail == true}">
                                    <div class="bg-warning refunded-order" :style="`width: calc(100% / ${orderDetailName.length + 1} * 2);`" v-if="order.is_partial_refunded == true">partially refunded</div>
                                    <div class="bg-danger settlement-fail-order" :style="`width: calc(100% / ${orderDetailName.length + 1} * 2);`" v-if="order.is_settlement_fail == true">settlement failed</div>
                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`">{{order.order_items[0].order_id}}</div>
                                    <div class="p-4 px-1 table-td text-primary" :style="`width: calc(100% / ${orderDetailName.length + 1})`">
                                        <router-link :to="{path: '/go-pos/order-detail?id=' + order.order_items[0].order_id}" :key="order.order_items[0].order_id" target='_blank'>
                                            <span>OD{{order.order_items[0].order_id}}</span>
                                        </router-link>
                                    </div>
                                    <div class="flex flex-col" :style="`width: calc(100% / ${orderDetailName.length + 1} * ${multiple_row_num + 0.5}); height: inherit;`">
                                        <div class="flex-center w-full" v-for="(item, item_index) in order.order_items" :key="item_index" :style="`height: calc(100% / ${order.order_items.length});`">
                                            <!-- <div class="px-1 h-full table-td" style="width: calc(100% / 7 * 3);" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    {{item.quantity}} x {{item.item_name}}
                                            </div>
                                            <div class="px-1 h-full table-td" style="width: calc(100% / 7 * 2);" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    ${{item.income.income_after_discount}}
                                            </div>
                                            <div class="px-1 h-full table-td" style="width: calc(100% / 7 * 2);" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    ${{item.income.commission}}
                                            </div> -->
                                            <div class="px-1 h-full table-td" :style="`width: calc(100% / ${multiple_row_num * 2 + 1} * 3);`" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    {{item.quantity}} x {{item.item_name}}
                                            </div>
                                            <div class="px-1 h-full table-td" :style="`width: calc(100% / ${multiple_row_num * 2 + 1} * 2);`" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    ${{+(Math.round(item.income.income_after_discount + "e+2") + "e-2")}}
                                            </div>
                                            <div class="px-1 h-full table-td" :style="`width: calc(100% / ${multiple_row_num * 2 + 1} * 2);`" 
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    ${{+(Math.round(item.income.commission + "e+2") + "e-2")}}
                                            </div>
                                            <div class="px-1 h-full table-td" :style="`width: calc(100% / ${multiple_row_num * 2 + 1} * 2);`" 
                                                v-if="incomeDetail.total.supply_share"
                                                :class="{'pt-4': item_index == 0, 'pb-4': item_index == order.order_items.length - 1, 'pt-2': item_index != 0}">
                                                    ${{+(Math.round(item.income.total_supply_share + "e+2") + "e-2")}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`" v-if="incomeDetail.total.card_charge && active_type.type != 'salary'">
                                        ${{getOrderDetailColumnValue(order.order_items, 'total_card_charge')}}
                                    </div>
                                    <!-- <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`" v-if="incomeDetail.total.supply_share">
                                        ${{getOrderDetailColumnValue(order.order_items, 'total_supply_share')}}
                                    </div> -->
                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`" v-if="incomeDetail.total.tip_after_charge">
                                        ${{+(Math.round(order.tip_after_charge + "e+2") + "e-2")}}
                                    </div>

                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`">${{+(Math.round(order.cash_income + "e+2") + "e-2")}}</div>
                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`">${{+(Math.round(order.check_income + "e+2") + "e-2")}}</div>
                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1})`">
                                        <div>
                                            <p>{{changeFormat(order.checkout_at)}}</p>
                                            <p>{{getTime(order.checkout_at)}}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1} * 1.5)`">${{getOrderDetailColumnValue(order.order_items, 'final_commission')}}</div> -->
                                    <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length + 1} * 1.5)`">${{order.final_commission}}</div>
                                </div>
                            </div>

                            <div class="flex mb-6 shadow-md rounded-item tr-total">
                                <div class="p-4 px-1 text-xl table-td" :style="`width: calc(100% / ${orderDetailName.length} * 3.5; text-shadow: 0 0 #000;`">TOTAL {{formatDate1(order_by_time.checkout_at)}}</div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`">${{getOrderDetailColumnTotal(order_by_time.order_items, 'income_after_discount')}}</div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`">${{getOrderDetailColumnTotal(order_by_time.order_items, 'commission')}}</div>

                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`" v-if="incomeDetail.total.supply_share">
                                    ${{getOrderDetailColumnTotal(order_by_time.order_items, 'total_supply_share')}}
                                </div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`" v-if="incomeDetail.total.card_charge && active_type.type != 'salary'">
                                    ${{getOrderDetailColumnTotal(order_by_time.order_items, 'total_card_charge')}}
                                </div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`" v-if="incomeDetail.total.tip_after_charge">
                                    <!-- ${{getOrderDetailColumnTotal(order_by_time.order_items, 'tip_income')}} -->
                                    ${{getTipTotal(order_by_time.order_items)}}
                                </div>

                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`">${{getCashCheckColumnTotal(order_by_time.order_items, 'cash_income')}}</div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`">${{getCashCheckColumnTotal(order_by_time.order_items, 'check_income')}}</div>
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length}`">
                                    <div>
                                        <p>{{changeFormat(order_by_time.checkout_at)}}</p>
                                        <p>{{getTime(order_by_time.checkout_at)}}</p>
                                    </div>
                                </div>
                                <!-- <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length} * 1.5`">${{getOrderDetailColumnTotal(order_by_time.order_items, 'final_commission')}}</div> -->
                                <div class="p-4 px-1 table-td" :style="`width: calc(100% / ${orderDetailName.length} * 1.5`">${{getFinalCommissionColumnTotal(order_by_time.order_items)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center w-full font-normal py-base" v-else>No data available</div>
                </div>
            </div>
        </div>
        <payroll-edit-staff-sidebar :editStaffConfig="editStaffConfig" :commissionList="commissionList" :active_staff="active_staff" :active_type="active_type" :detail_filter_days="detail_filter_days" :key="edit_staff_key" @ChangeStaffCommission="changeStaffCommission"></payroll-edit-staff-sidebar>
        <wage-per-hour-popup :wagePerHourPopup="wagePerHourPopup" />
    </div>
</template>

<script>
import moment from 'moment';
import { StringHelper } from "../../models/string_helper";
import { changeFormatHelper, formatExportDateString, formatExportUnderscoreDateString } from '../../helper/datetimeHelper';
import FileDownload from'js-file-download';
export default {
    name: 'payroll-detail-component',
    props: {
        showDetailData: {
            type: Object,
            default: null
        },
        active_staff: {
            type: Object,
            default: null
        },
        // active_type: {
        //     type: Object,
        //     default: null
        // },
        detail_filter_days: {
            type: Object,
            default: null
        }
    },
    data() {
        let format_export_date_string = formatExportDateString();
        let format_underscore_export_date_string = formatExportUnderscoreDateString();
        return {
            format_export_date_string,
            format_underscore_export_date_string,
            isOpenLoading: false,
            action_type: '',
            StringHelper,
            editStaffConfig: {
                isOpen: false
            },
            active_type: null,
            edit_staff_key: 0,
            totalTableData: null,
            orderTableData: null,
            orderDetailData: [],
            orderDetailName: ["no.", "order id", "services", "income", "commission", "cash income", "check income", "checkout at", "total"],
            multiple_row_num: 3,
            commissionData: null,
            salary_type: 0,
            approved_commission: false,
            wagePerHourPopup: {
                isOpen: false,
                item_info: null
            }
        }
    },
    watch: {
        incomeDetail: {
            immediate: true,
            deep: true,
            handler() {
                // console.log(this.incomeDetail);
                this.approved_commission = false;
                if(this.incomeDetail && this.incomeDetail.total && this.incomeDetail.employee) {
                    if(this.incomeDetail.employee.approved_commission != null) {
                        this.commissionData = this.incomeDetail.employee.approved_commission;
                        this.approved_commission = true;
                    } else {
                        this.commissionData = this.incomeDetail.employee.staff_commission;
                    }


                    // this.totalTableData = this.getTotalTableData();
                    if(this.incomeDetail.order) {
                        // this.orderDetailData = Object.values(this.incomeDetail.order);
                        // this.orderDetailData = Object.values(this.test_data);
                        this.orderDetailData = this.getOrderDetailData(this.incomeDetail.order);
                        this.orderDetailName = this.getOrderDetailName();
                        // console.log(this.incomeDetail);
                        // console.log(this.orderDetailData);
                    }
                    // this.active_type = { type: this.incomeDetail.employee.commission_type };
                    this.active_type = { type: 'commission' };
                    if(this.incomeDetail.employee) {
                        if(this.incomeDetail.employee.approved_commission != null) {
                            this.active_type.type = this.incomeDetail.employee.approved_commission.type;
                        } else {
                            this.active_type.type = this.incomeDetail.employee.staff_commission.type;
                        }
                    }
                    
                    if(this.commissionData != null && (this.commissionData.type == 'salary' || this.commissionData.type == 'salary_commission')) {
                        this.salary_type = this.commissionData.salary_type;
                    }

                    this.totalTableData = this.getTotalTableData();

                    this.edit_staff_key++;
                }
            }
        },
    },
    methods: {
        formatPercent(value) {
            // return Math.round((value/100) * 100 + Number.EPSILON ) / 100;
            return +(Math.round(value*100 + "e+2") + "e-2");
        },
        formatFloatNum(value) {
            return +(Math.round(value*100 + "e+5") + "e-5");
        },
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);

        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        getOrderDetailData(order_items) {
            let result = [];
            let list = Object.values(order_items);
            // console.log(list);
            if(list.length > 0) {
                let cur_day = list[0].checkout_at;
                let temp_arr = [];
                for(let i = 0; i < list.length; i++) {
                    // console.log(list[i])
                    if(this.compareDays(cur_day, list[i].checkout_at)) {
                        temp_arr.push(list[i]);
                    } else {
                        result.push({
                            checkout_at: cur_day,
                            order_items: temp_arr
                        });
                        temp_arr = [];
                        temp_arr.push(list[i]);
                        cur_day = list[i].checkout_at;
                    }
                }
                result.push({
                    checkout_at: cur_day,
                    order_items: temp_arr
                });
            }
            // console.log(result);
            return result;
        },
        getOrderDetailColumnValue(order_items, key) {
            let result = 0;
            if(order_items && order_items.length > 0) {
                for(let i = 0; i < order_items.length; i++) {
                    if(order_items[i].income) {
                        result += order_items[i].income[key];
                    }
                }
            }
            return +(Math.round(result + "e+2") + "e-2");
        },
        getOrderDetailColumnTotal(order_items_by_checkout_time, key) {
            // console.log(order_items_by_checkout_time);
            let list = order_items_by_checkout_time;
            let result = 0;
            if(list && list.length > 0) {
                for(let i = 0; i < list.length; i++) {
                    let order_items = list[i].order_items;
                    for(let j = 0; j < order_items.length; j++) {
                        let order = order_items[j];
                        if(order.income && order.income[key]) {
                            result += order.income[key];
                        }
                    }
                }
            }
            return +(Math.round(result + "e+2") + "e-2");
        },
        getCashCheckColumnTotal(order_items_by_checkout_time, key) {
            let list = order_items_by_checkout_time;
            let result = 0;
            if(list && list.length > 0) {
                for(let i = 0; i < list.length; i++) {
                    result += list[i][key];
                }
            }
            return +(Math.round(result + "e+2") + "e-2");
        },
        getTipTotal(order_items_by_checkout_time) {
            let list = order_items_by_checkout_time;
            let result = 0;
            if(list && list.length > 0) {
                for(let i = 0; i < list.length; i++) {
                    result += list[i].tip_after_charge;
                }
            }
            return +(Math.round(result + "e+2") + "e-2");
        },
        getFinalCommissionColumnTotal(order_items_by_checkout_time) {
            let list = order_items_by_checkout_time;
            let result = 0;
            if(list && list.length > 0) {
                for(let i = 0; i < list.length; i++) {
                    result += list[i].final_commission;
                }
            }
            return +(Math.round(result + "e+2") + "e-2");
        },
        changeFormat(day) {
            if(day) {
                return changeFormatHelper(day);
            } else {
                return 'N/A';
            }
        },
        getTime(date) {
            if(date) {
                return moment(date).format('hh:mm A');
            } else {
                return '';
            }
        },
        getTotalTableData() {
            let result = [];
            if(this.incomeDetail && this.incomeDetail != {}) {
                let data = this.incomeDetail.total;
                let commission_type = 'commission';
                if(this.incomeDetail.employee) {
                    if(this.incomeDetail.employee.approved_commission != null) {
                        commission_type = this.incomeDetail.employee.approved_commission.type;
                    } else {
                        commission_type = this.incomeDetail.employee.staff_commission.type;
                    }
                }
                if(!(commission_type == 'salary' && this.salary_type == 1)) {
                    if(data.income != null && data.income != undefined) {
                        result.push({ name: 'income', value: +(Math.round(data.income + "e+2") + "e-2") });
                    }
                    if(data.commission != null && data.commission != undefined) {
                        result.push({ name: 'commission', value: +(Math.round(data.commission + "e+2") + "e-2") });
                    }
                }
                if(!(commission_type == 'salary' && this.salary_type == 1)) {
                    if(data.supply_share) {
                        result.push({ name: 'supply share', value: +(Math.round(data.supply_share + "e+2") + "e-2") });
                    }
                }
                if(this.incomeDetail.employee && commission_type != 'salary') {
                    if(data.card_charge) {
                        result.push({ name: 'card charge', value: +(Math.round(data.card_charge + "e+2") + "e-2") });
                    }
                }
                if(this.incomeDetail.employee && commission_type != 'commission') {
                    if(data.salary != null && data.salary != undefined) {
                        if(this.salary_type == 0) {
                            result.push({ name: 'salary', value: +(Math.round(data.salary + "e+2") + "e-2") });
                        } else {
                            result.push({ name: 'wage per hour', value: +(Math.round(data.salary_per_hour + "e+2") + "e-2") });
                            result.push({ name: 'working hours', value: data.working_hours });
                        }
                    }
                }
                if(data.tip_after_charge) {
                    result.push({ name: 'tip', value: +(Math.round(data.tip_after_charge + "e+2") + "e-2") });
                }
                if(data.deduction != null && data.deduction != undefined) {
                    result.push({ name: 'deduction', value: +(Math.round(data.deduction + "e+2") + "e-2") });
                }
                if(data.cash_income != null && data.cash_income != undefined) {
                    result.push({ name: 'cash income', value: +(Math.round(data.cash_income + "e+2") + "e-2") });
                }
                if(data.check_income != null && data.check_income != undefined) {
                    result.push({ name: 'check income', value: +(Math.round(data.check_income + "e+2") + "e-2") });
                }
                if(data.total != null && data.total != undefined) {
                    result.push({ name: 'total', value: +(Math.round(data.total + "e+2") + "e-2") });
                }
            }
            return result;
        },
        getOrderDetailName() {
            let result = ["no.", "order id", "items", "income", "commission"];
            if(this.incomeDetail && this.incomeDetail != {}) {
                let commission_type = 'commission';
                if(this.incomeDetail.employee) {
                    if(this.incomeDetail.employee.approved_commission != null) {
                        commission_type = this.incomeDetail.employee.approved_commission.type;
                    } else {
                        commission_type = this.incomeDetail.employee.staff_commission.type;
                    }
                }
                let total_data = this.incomeDetail.total;
                this.multiple_row_num = 3;
                if(total_data.supply_share) {
                    result.push("supply share");
                    this.multiple_row_num = 4;
                }
                if(commission_type != 'salary' && total_data.card_charge) {
                    result.push("card charge");
                }
                if(total_data.tip_after_charge) {
                    result.push("tip");
                }
                result.push("cash income");
                result.push("check income");
                result.push("checkout at");
                result.push("total");
            }
            return result;
        },
        formatDate(date) {
            return moment(date).format('MMMM DD, YYYY');
        },
        formatDate1(date) {
            return moment(date).format(formatExportDateString());
        },
        getDuration(start_date, end_date) {
            return moment(end_date).diff(moment(start_date), 'days') + 1;
        },
        compareDays(date1, date2) {
            if(date1 && date2 && moment(date1).format('YYYY-MM-DD') == moment(date2).format('YYYY-MM-DD')) {
                return true;
            }
            return false;
        },
        exportIncomeDetail() {
            let data = {};
            if(this.active_staff) {
                data.staff_id = this.active_staff.user_id;
            }
            if(this.showDetailData && this.showDetailData.start_date) {
                data.start_date = moment(this.showDetailData.start_date).format('MM/DD/YYYY');
            }
            if(this.showDetailData && this.showDetailData.end_date) {
                data.end_date = moment(this.showDetailData.end_date).format('MM/DD/YYYY');
            }
            let export_file_name = 'PayrollDetail';
            if(this.active_staff && this.showDetailData && this.showDetailData.start_date && this.showDetailData.end_date) {
                export_file_name = `${this.active_staff.name.split(' ').join('_')}_${moment(data.start_date).format(this.format_underscore_export_date_string)}_to_${moment(data.end_date).format(this.format_underscore_export_date_string)}_PayrollDetail`;
            }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = "Export Income Detail";
            this.$store.dispatch('goPos/EXPORT_INCOME_DETAIL', data).then((res) => {
                // console.log(res);
                FileDownload(res.data, `${export_file_name}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: "Export Income Detail Success",
                    color: "success",
                    position: "top-right"
                });
            })
        },
        changeStaffCommission(data) {
            this.$emit('ChangeStaffCommission', data);
        },
        async openWagePerHourPopup() {
            if(this.showDetailData && this.incomeDetail && this.incomeDetail.employee) {
                let params = {
                    start_date: this.showDetailData.start_date,
                    end_date: this.showDetailData.end_date,
                    staff_id: this.incomeDetail.employee.user_id
                }

                this.openLoadingInDiv();
                await this.$store.dispatch("goPos/GET_SALARY_DETAIL", params);
                this.closeLoading();
            }
            this.wagePerHourPopup.item_info = {
                start_date: this.showDetailData.start_date,
                end_date: this.showDetailData.end_date,
                employee: this.incomeDetail.employee
            };
            this.wagePerHourPopup.isOpen = true;
        }
    },
    computed:{
        commissionList(){
          return this.$store.getters["staffList/commissionList"];
        },
        incomeDetail() {
            return this.$store.getters["goPos/incomeDetail"];
        }
    },
}
</script>